import { useState } from 'react';
import { RiMenuAddLine } from 'react-icons/ri';

import { TrackInfo } from './TrackInfo';
import { Controls } from './Controls';
import { ProgressBar } from './ProgressBar';
import { VolumeControl } from './VolumeControl';
import { PlayList } from './PlayList';

import '../styles/customize-progress-bar.css'

export const AudioPlayer = () => {
  // const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <div>
      <div style={{ borderRadius: "4px", minHeight: "8px", backgroundColor: "#4a5267", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "9px", flexDirection: "row", color: "white", padding: "0.5rem 10px" }}>
        <TrackInfo />
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: "1px", margin: "0 auto", flex: "1 1 auto" }}>
          <Controls />
          <ProgressBar />
        </div>


        <div
          // className="flex items-center gap-2 text-gray-400"
          style={{ display: "flex", alignItems: "center", gap: "2px", color: "#99a1af" }}>
          <VolumeControl />
          {/* <button onClick={() => setOpenDrawer((prev) => !prev)}>
            <RiMenuAddLine />
          </button> */}
        </div>
      </div>

      {/* <div
        style={{overflow: "hidden", maxHeight: (openDrawer)? "288px" : "0px"}}
        // className={`transition-max-height duration-300 ease-in-out overflow-hidden ${openDrawer ? 'max-h-72' : 'max-h-0'}`}
      >
        <div
          // className="bg-[#4c4848] text-white max-h-72 overflow-y-auto"
          style={{ backgroundColor: "#4c4848", color: "white", maxHeight: "288px", overflowY: "auto" }}>
          <PlayList />
        </div>
      </div> */}
    </div>
  );

  // return (
  //   <div className='bg-cyan-500'>
  //     <div className="min-h-8 bg-[#2e2d2d] flex flex-col gap-9 lg:flex-row justify-between items-center text-white p-[0.5rem_10px]">
  //       <TrackInfo />
  //       <div className="w-full flex flex-col items-center gap-1 m-auto flex-1">
  //         <Controls />
  //         <ProgressBar />
  //       </div>
  //       <div className="flex items-center gap-2 text-gray-400">
  //         <VolumeControl />
  //         <button onClick={() => setOpenDrawer((prev) => !prev)}>
  //           <RiMenuAddLine />
  //         </button>
  //       </div>
  //     </div>

  //     <div
  //       className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
  //         openDrawer ? 'max-h-72' : 'max-h-0'
  //       }`}
  //     >
  //       <div className="bg-[#4c4848] text-white max-h-72 overflow-y-auto">
  //         <PlayList />
  //       </div>
  //     </div>
  //   </div>
  // );
};
